import { HTTP } from "@/config/http-constants";
export default {
  generateExport(type) {
    return HTTP.get(`/api/export?type=${type}`, { responseType : 'blob' });
  },
};